import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'
import Shimmer from "react-shimmer-effect";
import CustomSelect from "../../../../helpers/ui/CustomSelect"
import InputTime from '../../../../helpers/ui/InputTime'

import UpdateBloc from './Blocs/UpdateBloc'

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            detail: null,
            dataForm: {},
            days: [
                {
                    name: 'Senin',
                    number: 1,
                    type: 'Hari Kerja'
                },
                {
                    name: 'Selasa',
                    number: 2,
                    type: 'Hari Kerja'
                },
                {
                    name: 'Rabu',
                    number: 3,
                    type: 'Hari Kerja'
                },
                {
                    name: 'Kamis',
                    number: 4,
                    type: 'Hari Kerja'
                },
                {
                    name: 'Jumat',
                    number: 5,
                    type: 'Hari Kerja'
                },
                {
                    name: 'Sabtu',
                    number: 6,
                    type: 'Hari Libur'
                },
                {
                    name: 'Minggu',
                    number: 7,
                    type: 'Hari Libur'
                }
            ],
            type: [
                {
                    value: 'Hari Kerja',
                    label: 'Hari Kerja'
                },
                {
                    value: 'Hari Libur',
                    label: 'Hari Libur'
                },
            ],
            totalRow: null
        }
    }

    submitData = async () => {
        await this.updateBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                pattern_uuid: this.state.detail?.working_pattern_uuid,
                working_hours_working_pattern_id: this.state.detail?.working_pattern_id,
                ...values
            },
            confirm: true
        })
        console.log(values)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.listChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            listWorkingHour: response.result,
                            totalRow: response.total
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({ uuid: queryParams.get('puuid') })
        this.updateBloc.fetchList({ uuid: queryParams.get('puuid') })
    }

    componentWillUnmount() {
        this.updateBloc.createChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Jam Kerja</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                                Nama Pola
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.working_pattern_name !== "" ? this.state.detail.working_pattern_name : '-'}</>
                                                        : <Shimmer><div style={{ width: '30%', height: 15 }}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="working_pattern_name"
                                                className="col-md-2 col-form-label"
                                            >
                                                Jam Kerja <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <div className="table-responsive">
                                                    <Table className="table-bordered table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>Hari</th>
                                                                <th style={{ width: '180px' }}>Jenis</th>
                                                                {/* backup code yg di comment */}
                                                                {/* <th style={{ width: '110px' }}>{(this.state.detail?.working_pattern_type == 0 ? 'Jam Mulai Dapat Absen' : 'Jam Masuk')}</th> */}
                                                                {/* perubahan wfo/wfh ada jam mulai dan selesai */}
                                                                <th style={{ width: '110px' }}>{(0 == 0 ? 'Jam Mulai Dapat Absen' : 'Jam Masuk')}</th>
                                                                {
                                                                    // this.state.detail?.working_pattern_type == 0 ?
                                                                    0 == 0 ?
                                                                        <th style={{ width: '110px' }}>Jam Masuk</th>
                                                                        : ''
                                                                }
                                                                <th style={{ width: '110px' }}>Jam Pulang</th>
                                                                {
                                                                    // this.state.detail?.working_pattern_type == 0 ?
                                                                    0 == 0 ?
                                                                        <th style={{ width: '110px' }}>Jam Akhir Absen</th>
                                                                        : ''
                                                                }
                                                                <th style={{ width: '110px' }}>Mulai Istirahat</th>
                                                                <th style={{ width: '110px' }}>Selesai Istirahat</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.totalRow == null ?
                                                                    <tr>
                                                                        {/* <td colSpan={this.state.detail?.working_pattern_type == 0 ? "8" : "6"}> */}
                                                                        <td colSpan={0 == 0 ? "8" : "6"}>
                                                                            <Shimmer><div style={{ width: '100%', height: 35 }}></div></Shimmer>
                                                                        </td>
                                                                    </tr>
                                                                    :
                                                                    this.state.totalRow < 1 ?
                                                                        this.state.days.map((data, index) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>
                                                                                        {data.name}
                                                                                        <AvField
                                                                                            name={`working_hours_day_name[${index}]`}
                                                                                            type="hidden"
                                                                                            value={data.name}
                                                                                        />
                                                                                        <AvField
                                                                                            name={`working_hours_day_number[${index}]`}
                                                                                            type="hidden"
                                                                                            value={index + 1}
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <CustomSelect
                                                                                            name={`working_hours_type[${index}]`}
                                                                                            errorMessage="Pilih Jenis"
                                                                                            options={this.state.type}
                                                                                            validate={{ required: { value: true } }}
                                                                                            placeholder="Pilih Jenis"
                                                                                            defaultValue={data.type}
                                                                                        />
                                                                                    </td>
                                                                                    {
                                                                                        // this.state.detail?.working_pattern_type == 0 ?
                                                                                        0 == 0 ?
                                                                                            <td>
                                                                                                <InputTime
                                                                                                    name={`working_hours_first_start[${index}]`}
                                                                                                    placeholder="Jam Masuk..."
                                                                                                    type="time"
                                                                                                    errorMessage="Masukkan Jam Mulai Dapat Absen"
                                                                                                    className="form-control"
                                                                                                    validate={{ required: { value: true } }}
                                                                                                    id="working_hours_first_start"
                                                                                                // value={this.state.dataForm?.working_hours_first_start}
                                                                                                />
                                                                                            </td> : ''
                                                                                    }
                                                                                    <td>
                                                                                        <InputTime
                                                                                            name={`working_hours_start[${index}]`}
                                                                                            placeholder="Jam Masuk..."
                                                                                            type="time"
                                                                                            errorMessage="Masukkan Jam Masuk"
                                                                                            className="form-control"
                                                                                            validate={{ required: { value: true } }}
                                                                                            id="working_hours_start"
                                                                                        // value={this.state.dataForm?.working_hours_start}
                                                                                        />
                                                                                    </td>

                                                                                    <td>
                                                                                        <InputTime
                                                                                            name={`working_hours_end[${index}]`}
                                                                                            placeholder="Jam Pulang..."
                                                                                            type="time"
                                                                                            errorMessage="Masukkan Jam Pulang"
                                                                                            className="form-control"
                                                                                            validate={{ required: { value: true } }}
                                                                                            id="working_hours_end"
                                                                                        // value={this.state.dataForm?.working_hours_end}
                                                                                        />
                                                                                    </td>
                                                                                    {
                                                                                        // this.state.detail?.working_pattern_type == 0 ?
                                                                                        0 == 0 ?
                                                                                            <td>
                                                                                                <InputTime
                                                                                                    name={`working_hours_last_end[${index}]`}
                                                                                                    placeholder="Jam Pulang Akhir..."
                                                                                                    type="time"
                                                                                                    errorMessage="Masukkan Jam Akhir Absen"
                                                                                                    className="form-control"
                                                                                                    validate={{ required: { value: true } }}
                                                                                                    id="working_hours_last_end"
                                                                                                // value={this.state.dataForm?.working_hours_last_end}
                                                                                                />
                                                                                            </td>
                                                                                            : ''
                                                                                    }
                                                                                    <td>
                                                                                        <InputTime
                                                                                            name={`working_hours_breaktime_start[${index}]`}
                                                                                            placeholder="Mulai Istirahat..."
                                                                                            type="time"
                                                                                            errorMessage="Masukkan Mulai Istirahat"
                                                                                            className="form-control"
                                                                                            validate={{ required: { value: true } }}
                                                                                            id="working_hours_breaktime_start"
                                                                                        // value={this.state.dataForm?.working_hours_breaktime_start}
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <InputTime
                                                                                            name={`working_hours_breaktime_end[${index}]`}
                                                                                            placeholder="Selesai Istirahat..."
                                                                                            type="time"
                                                                                            errorMessage="Masukkan Selesai Istirahat"
                                                                                            className="form-control"
                                                                                            validate={{ required: { value: true } }}
                                                                                            id="working_hours_breaktime_end"
                                                                                        // value={this.state.dataForm?.working_hours_breaktime_end}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                        :
                                                                        this.state.listWorkingHour?.map((data, index) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>
                                                                                        {data.working_hours_day_name}
                                                                                        <AvField
                                                                                            name={`working_hours_day_name[${index}]`}
                                                                                            type="hidden"
                                                                                            value={data.working_hours_day_name}
                                                                                        />
                                                                                        <AvField
                                                                                            name={`working_hours_day_number[${index}]`}
                                                                                            type="hidden"
                                                                                            value={index + 1}
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <CustomSelect
                                                                                            name={`working_hours_type[${index}]`}
                                                                                            errorMessage="Pilih Jenis"
                                                                                            options={this.state.type}
                                                                                            validate={{ required: { value: true } }}
                                                                                            placeholder="Pilih Jenis"
                                                                                            defaultValue={data.working_hours_type}
                                                                                        />
                                                                                    </td>
                                                                                    {
                                                                                        // this.state.detail?.working_pattern_type == 0 ?
                                                                                        0 == 0 ?
                                                                                            <td>
                                                                                                <InputTime
                                                                                                    name={`working_hours_first_start[${index}]`}
                                                                                                    placeholder="Jam Masuk..."
                                                                                                    type="time"
                                                                                                    errorMessage="Masukkan Jam Mulai Dapat Absen"
                                                                                                    className="form-control"
                                                                                                    validate={{ required: { value: true } }}
                                                                                                    id="working_hours_first_start"
                                                                                                    defaultValue={data.working_hours_first_start}
                                                                                                />
                                                                                            </td>
                                                                                            : ''
                                                                                    }
                                                                                    <td>
                                                                                        <InputTime
                                                                                            name={`working_hours_start[${index}]`}
                                                                                            placeholder="Jam Masuk..."
                                                                                            type="time"
                                                                                            errorMessage="Masukkan Jam Masuk"
                                                                                            className="form-control"
                                                                                            validate={{ required: { value: true } }}
                                                                                            id="working_hours_start"
                                                                                            defaultValue={data.working_hours_start}
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <InputTime
                                                                                            name={`working_hours_end[${index}]`}
                                                                                            placeholder="Jam Pulang..."
                                                                                            type="time"
                                                                                            errorMessage="Masukkan Jam Pulang"
                                                                                            className="form-control"
                                                                                            validate={{ required: { value: true } }}
                                                                                            id="working_hours_end"
                                                                                            defaultValue={data.working_hours_end}
                                                                                        />
                                                                                    </td>
                                                                                    {
                                                                                        // this.state.detail?.working_pattern_type == 0 ?
                                                                                        0 == 0 ?
                                                                                            <td>
                                                                                                <InputTime
                                                                                                    name={`working_hours_last_end[${index}]`}
                                                                                                    placeholder="Jam Pulang Akhir..."
                                                                                                    type="time"
                                                                                                    errorMessage="Masukkan Jam Akhir Absen"
                                                                                                    className="form-control"
                                                                                                    validate={{ required: { value: true } }}
                                                                                                    id="working_hours_last_end"
                                                                                                    defaultValue={data.working_hours_last_end}
                                                                                                />
                                                                                            </td>
                                                                                            : ''
                                                                                    }
                                                                                    <td>
                                                                                        <InputTime
                                                                                            name={`working_hours_breaktime_start[${index}]`}
                                                                                            placeholder="Mulai Istirahat..."
                                                                                            type="time"
                                                                                            errorMessage="Masukkan Mulai Istirahat"
                                                                                            className="form-control"
                                                                                            validate={{ required: { value: true } }}
                                                                                            id="working_hours_breaktime_start"
                                                                                            defaultValue={data.working_hours_breaktime_start}
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <InputTime
                                                                                            name={`working_hours_breaktime_end[${index}]`}
                                                                                            placeholder="Selesai Istirahat..."
                                                                                            type="time"
                                                                                            errorMessage="Masukkan Selesai Istirahat"
                                                                                            className="form-control"
                                                                                            validate={{ required: { value: true } }}
                                                                                            id="working_hours_breaktime_end"
                                                                                            defaultValue={data.working_hours_breaktime_end}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                            }

                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>
                                        </Row>


                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to='/master/pola_kerja.html?' />
                    : null}
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);
